'use client';

import React, { useEffect } from 'react';
import { MapPin } from 'lucide-react';
import { motion, useAnimation, Variants } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

export default function Storelocation() {
  const store = process.env.NEXT_PUBLIC_STORE_NAME || 'Our Store';
  const controls = useAnimation();
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  useEffect(() => {
    if (inView) {
      controls.start('visible');
    }
  }, [controls, inView]);

  const containerVariants: Variants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: 'easeOut',
        staggerChildren: 0.2,
      },
    },
  };

  const childVariants: Variants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut',
      },
    },
  };

  return (
    <motion.section
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={containerVariants}
      className="bg-gradient-to-b from-gray-50 to-white py-12"
    >
      <motion.h1
        variants={childVariants}
        className="text-4xl md:text-5xl font-extrabold text-center text-gray-900 mb-6"
      >
        FIND US HERE
      </motion.h1>
      <motion.hr
        variants={childVariants}
        className="w-24 mx-auto border-t-4 border-blue-600 mb-8"
      />
      <div className="max-w-3xl mx-auto text-center">
        <motion.h3
          variants={childVariants}
          className="text-2xl md:text-3xl font-semibold text-gray-700 mb-4"
        >
          {store}, Chennai
        </motion.h3>
        <motion.p
          variants={childVariants}
          className="text-lg text-gray-600 mb-6 flex items-center justify-center gap-2"
        >
          <MapPin className="text-blue-600 w-5 h-5" />
          <span>
            C1 G1 Sudarsan silver dale apartments,
            Surya Avenue 1st street, Near Palavaram
            taluk office, Chrompet Chennai 45

            +91 88077 42710
          </span>
        </motion.p>
        <motion.div
          variants={childVariants}
          className="relative rounded-lg overflow-hidden shadow-lg"
        >
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3885.2903818642985!2d80.24636867484452!3d13.144074487187348!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a526511d23cf81d%3A0xb09d0167610e6222!2sVilva%20Clothings%20%7C%20Tamil%20Tshirt%20Store!5e0!3m2!1sen!2sin!4v1738297105483!5m2!1sen!2sin"
            width="100%"
            height="450"
            loading="lazy"
            className="border-0"
            title="Store Location Map"
          />
        </motion.div>
      </div>
    </motion.section>
  );
}